import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-admin-users-management',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="users-management-container">
      <div class="header">
        <h2>Gestion des Utilisateurs et Rôles</h2>
      </div>

      <div class="management-tabs">
        <nav class="nav nav-tabs">
          <a class="nav-link" 
            routerLink="./list" 
            routerLinkActive="active">
            Utilisateurs
          </a>
          <a class="nav-link" 
            routerLink="./roles" 
            routerLinkActive="active">
            Rôles et Permissions
          </a>
        </nav>
      </div>

      <div class="tab-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: [`
    .users-management-container {
      padding: 20px;
      
      .header {
        margin-bottom: 20px;
        h2 {
          font-size: 24px;
          color: #333;
        }
      }

      .management-tabs {
        margin-bottom: 20px;
        
        .nav-tabs {
          border-bottom: 2px solid #dee2e6;
          
          .nav-link {
            color: #495057;
            border: none;
            padding: 12px 20px;
            
            &.active {
              color: var(--bs-primary);
              border-bottom: 2px solid var(--bs-primary);
            }
            
            &:hover {
              border-color: transparent;
              isolation: isolate;
            }
          }
        }
      }

      .tab-content {
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
    }
  `]
})
export class AdminUsersManagementComponent {} 